import { Component, input } from '@angular/core';
import { TooltipPosition } from '../tooltip/tooltip-position';
import { TooltipModule } from '../tooltip/tooltip.module';

@Component({
  selector: 'app-select2-option',
  templateUrl: './select2-option.component.html',
  host: { class: 'block min-w-0' },
  imports: [TooltipModule],
})
export class Select2OptionComponent {
  readonly label = input<string>();
  readonly icon = input<string>();
  readonly description = input<string>();

  public TooltipPosition = TooltipPosition;
}
